import uiRouter from '@uirouter/angularjs';
/**
 * @ngdoc service
 * @name eventix.common.services.TipStore
 * @description A repository of short snippets with tips and tricks.
 */
export default angular.module('eventix.common.services.tipStore',[uiRouter])
    .factory('TipStore', function($timeout, $state) {
        let timer;
        let selected;
        const interval = 2000;
        const Tips = {
            dashboard: [
                'Did you know that we provide powerful marketing tools to boost ticket sales.',
                'Did you know that through the open API, you are able to build custom integrations'
            ],
            shop: [
                'Dankuwel voor uw geduld'
            ],
            /**
             * @ngdoc method
             * @name eventix.common.services.TipStore#start
             * @methodOf eventix.common.services.TipStore
             * @description Select a tip from the correct repository and start a timer to refresh it after 2 sec
             *
             * @param {String} [subdomain=dashboard] Type of tip, dashboard or shop
             * @returns {Promise} The $timeout promise
             */
            start: function(subdomain = 'dashboard') {
                this.selected = _.sample(Tips[subdomain]);
                return setTimer.bind(Tips, subdomain);
            },
            /**
             * @ngdoc method
             * @name eventix.common.services.TipStore#stop
             * @methodOf eventix.common.services.TipStore
             * @description Stop the timer
             *
             * @returns {Boolean} True if task hasn't executed yet and was succesfully canceled
             */
            stop: function() {
                return $timeout.cancel(timer);
            }
        };
        /**
         * @ngdoc property
         * @name eventix.common.services.TipStore#selected
         * @propertyOf eventix.common.services.TipStore
         * @description The currently selected tip
         */
        Tips.selected = _.sample(Tips.dashboard);

        function setTimer(subdomain) {
            timer = $timeout(() => {
                this.selected = _.sample(this[subdomain]);
            }, interval);
            timer.then(setTimer.bind(this, subdomain));
            return timer;
        }

        return Tips;
    }).name;
